import React from 'react';
import styles from './Main.module.sass';
import Section, { SectionBackgroundStyle } from '../../reusable/section/Section';
import Oblong from '../../assets/oblong_d.svg';
import MobileSpacer, { SpacerSize } from '../../reusable/mobile_spacer/MobileSpacer';
import RevealImage from '../../reusable/reveal/RevealImage';

export default class Main extends React.Component {

  render() {
    return (
      <Section style={SectionBackgroundStyle.light}>
        <RevealImage className={styles.Oblong} src={Oblong} />
        <MobileSpacer size={SpacerSize.small} />
        <h1 className={styles.Container}>
          <div className={styles.Item}>Meet the</div>
          <div className={styles.Item}>most team.</div>
        </h1>
      </Section>
    )
  }

}